import { Box } from "@mui/material"

const AccountDelete = () => {
  return (
    <Box sx={{ fontWeight: 600, fontSize: 18, mt: 4 }}>
      You account has been deleted.
    </Box>
  )
}

export default AccountDelete
